import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getPaymentDetails,
  updatePayment,
} from "../../services/paymentService";

const EditPayment = () => {
  const { paymentId, projectId } = useParams();
  const navigate = useNavigate();

  const [payment, setPayment] = useState(null);
  const [title, setTitle] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [status, setStatus] = useState("completed");
  const [error, setError] = useState("");

  const goBack = () => {
    navigate(`/payments/${projectId}`);
  };

  useEffect(() => {
    async function fetchPaymentDetails() {
      try {
        const data = await getPaymentDetails(paymentId);
        setPayment(data);
        setTitle(data.title);
        setAmount(data.amount);
        setPaymentDate(data.paymentDate);
        setStatus(data.status);
      } catch {
        setError("Failed to load payment details.");
      }
    }

    fetchPaymentDetails();
  }, [paymentId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const paymentData = {
        title,
        amount: parseFloat(amount),
        paymentDate,
        status,
      };

      await updatePayment(paymentId, paymentData);
      navigate(`/payments/${projectId}`);
    } catch {
      setError("An error occurred while updating the payment.");
    }
  };

  if (!payment)
    return <div className="p-6 text-center">Loading payment details...</div>;

  return (
    <div className="p-4 md:p-6 max-w-2xl mx-auto space-y-6">
      {/* HEADER */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <h1 className="text-2xl font-bold">✏️ Edit Payment</h1>

        <button
          onClick={goBack}
          className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition"
        >
          ← Back
        </button>
      </div>

      {/* FORM CARD */}
      <div className="bg-white p-6 rounded-xl shadow-sm border space-y-4">
        {error && (
          <p className="text-red-500 text-sm text-center">{error}</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* TITLE */}
          <div>
            <label className="block font-medium mb-1">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring focus:ring-blue-200"
              required
            />
          </div>

          {/* AMOUNT */}
          <div>
            <label className="block font-medium mb-1">Amount</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring focus:ring-blue-200"
              required
            />
          </div>

          {/* PAYMENT DATE */}
          <div>
            <label className="block font-medium mb-1">Payment Date</label>
            <input
              type="date"
              value={paymentDate}
              onChange={(e) => setPaymentDate(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring focus:ring-blue-200"
              required
            />
          </div>

          {/* STATUS */}
          <div>
            <label className="block font-medium mb-1">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg"
            >
              <option value="completed">Completed</option>
            </select>
          </div>

          {/* SUBMIT */}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2.5 rounded-lg hover:bg-blue-700 transition font-medium"
          >
            Update Payment
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditPayment;
